import { driver } from "driver.js";
import "driver.js/dist/driver.css";

let drv;
export function getDriver() {
  if (!drv) {
    drv = driver({  
        animate: true,
        overlayOpacity: 0.45,
        nextBtnText: "다음",
        prevBtnText: "이전",
        doneBtnText: "완료",
        closeBtnText: "닫기",
        popoverClass: "driver-theme-bs",
    });
    
  }
  return drv;
}